import { useLocalization } from '@lib/localization';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useState } from 'react';

interface DeleteConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
  warningSubtitle?: string;
}

const DeleteConfirmationDialog = ({ open, onClose, onConfirm, warningSubtitle }: DeleteConfirmationDialogProps) => {
  const [isLoading, setLoading] = useState(false);
  const { t } = useLocalization();

  return (
    <Dialog
      open={open}
      onClose={!isLoading ? onClose : undefined}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
    >
      <DialogTitle id="delete-dialog-title">
        {t('General_ConfirmDelete_Title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-dialog-description">
          {t('General_ConfirmDelete_Content')}
        </DialogContentText>
        {warningSubtitle &&
          <DialogContentText id="delete-dialog-description" color='error'>
            {warningSubtitle}
          </DialogContentText>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" disabled={isLoading}>
          {t('Common_Cancel')}
        </Button>
        <Button onClick={async () => {
          setLoading(true);

          await onConfirm();
          onClose();

          setLoading(false);
        }} color="error" autoFocus disabled={isLoading}>
          {t('Common_Delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
